import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, FormGroup, Row } from 'reactstrap';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';

import Select from '../../../common/forms/select/Select';
import FormItem from '../../../common/forms/FormItem';
import PreventiveTaskSelect from '../../../common/forms/select/PreventiveTaskSelect';
import HcmDepartmentSelect from '../../../common/forms/select/HcmDepartmentSelect';
import HcmAreaSelect from '../../../common/forms/select/HcmAreaSelect';
import HcmPositionSelect from '../../../common/forms/select/HcmPositionSelect';
import UserSelect from '../../../common/forms/select/UserSelect';

import { PREVENTIVE_TASK_ASSIGNEE_SCOPE } from '../../../../config/constants';

import { enumToSelectOptions } from '../../../../utils/enum';
import { isRequired } from '../../../../utils/validators';

const FORM_NAME = 'PreventiveTaskAssigneeForm';

const getSelectValue = (field) => {
  if (field && typeof field === 'object') {
    return field.value;
  }

  return field;
};

const validatePreventiveTasks = (value) => {
  if (!Array.isArray(value) || value.length === 0) {
    return 'Seleccione al menos una tarea programada';
  }

  return undefined;
};

const PreventiveTaskAssigneeFormFields = ({
  assignmentScope,
  organization,
  department,
  dispatchChangeField,
}) => {
  const selectedAssignmentScope = getSelectValue(assignmentScope);

  const selectedOrganizationId = getSelectValue(organization);

  const selectedDepartmentId = getSelectValue(department);

  const assignmentScopeOptions = enumToSelectOptions(
    PREVENTIVE_TASK_ASSIGNEE_SCOPE,
  );

  const onAssignmentScopeChange = () => {
    dispatchChangeField(FORM_NAME, 'positionId', null);

    dispatchChangeField(FORM_NAME, 'userId', null);
  };

  const onDepartmentChange = () => {
    dispatchChangeField(FORM_NAME, 'areaId', null);
  };

  const departmentAndAreaFields = selectedAssignmentScope && (
    <Row>
      <Col md="4">
        <FormGroup row>
          <FormItem label="Departamento" required>
            <Field
              name="departmentId"
              component={HcmDepartmentSelect}
              organizationId={selectedOrganizationId}
              placeholder="Seleccione departamento"
              validate={[isRequired]}
              isClearable
              isDisabled={!selectedOrganizationId}
              onValueChange={onDepartmentChange}
            />
          </FormItem>
        </FormGroup>
      </Col>

      <Col md="4">
        <FormGroup row>
          <FormItem label="Área" required>
            <Field
              name="areaId"
              component={HcmAreaSelect}
              organizationId={selectedDepartmentId}
              placeholder="Seleccione área"
              validate={[isRequired]}
              isClearable
              isDisabled={!selectedOrganizationId || !selectedDepartmentId}
            />
          </FormItem>
        </FormGroup>
      </Col>
    </Row>
  );

  return (
    <Card className="mb-3">
      <CardHeader>Asignación de Tareas Programadas</CardHeader>

      <CardBody>
        <Row>
          <Col md="6">
            <FormGroup row>
              <FormItem label="Tareas Programadas" required>
                <Field
                  name="preventiveTaskIds"
                  component={PreventiveTaskSelect}
                  placeholder="Seleccione una o varias tareas"
                  validate={[validatePreventiveTasks]}
                  isMulti
                  isClearable
                  closeMenuOnSelect={false}
                  allowRepeatedOptions={false}
                />
              </FormItem>
            </FormGroup>
          </Col>

          <Col md="6">
            <FormGroup row>
              <FormItem label="Asignar a" required>
                <Field
                  name="assignmentScope"
                  component={Select}
                  options={assignmentScopeOptions}
                  placeholder="Seleccione tipo de asignación"
                  validate={[isRequired]}
                  isClearable
                  onValueChange={onAssignmentScopeChange}
                />
              </FormItem>
            </FormGroup>
          </Col>
        </Row>

        {departmentAndAreaFields}

        {selectedAssignmentScope ===
          PREVENTIVE_TASK_ASSIGNEE_SCOPE.ROLE.value && (
          <Row>
            <Col md="6">
              <FormGroup row>
                <FormItem label="Rol / Cargo" required>
                  <Field
                    name="positionId"
                    component={HcmPositionSelect}
                    placeholder="Seleccione rol o cargo"
                    validate={[isRequired]}
                    isClearable
                  />
                </FormItem>
              </FormGroup>
            </Col>
          </Row>
        )}

        {selectedAssignmentScope ===
          PREVENTIVE_TASK_ASSIGNEE_SCOPE.PERSON.value && (
          <Row>
            <Col md="6">
              <FormGroup row>
                <FormItem label="Personal" required>
                  <Field
                    name="userId"
                    component={UserSelect}
                    placeholder="Seleccione personal"
                    validate={[isRequired]}
                    isClearable
                  />
                </FormItem>
              </FormGroup>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

PreventiveTaskAssigneeFormFields.propTypes = {
  assignmentScope: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),

  organization: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),

  department: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),

  dispatchChangeField: PropTypes.func.isRequired,
};

PreventiveTaskAssigneeFormFields.defaultProps = {
  assignmentScope: null,
  organization: null,
  department: null,
};

const mapDispatchToProps = {
  dispatchChangeField: change,
};

export default connect(
  null,
  mapDispatchToProps,
)(PreventiveTaskAssigneeFormFields);
